import React from 'react'
import { JSX } from 'react'
import { AllMethodsTypes, methodOptions } from 'syncra-storybook/shared/utils'

export const getMethodMeta = (
  methodName: string,
  className = ''
): { title: string; icon: JSX.Element | null } => {
  const matchedKey = (Object.keys(AllMethodsTypes) as Array<keyof typeof AllMethodsTypes>).find(
    (key) => AllMethodsTypes[key] === methodName
  )

  if (!matchedKey) {
    return { title: methodName, icon: null }
  }

  const key = AllMethodsTypes[matchedKey] as AllMethodsTypes
  const option = methodOptions[key]

  const iconWithClass = option?.icon ? React.cloneElement(option.icon, { className }) : null

  return {
    title: option?.title ?? methodName,
    icon: iconWithClass,
  }
}
